import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from './common/Logo'

function ErrorPage() {
  const navigate = useNavigate()
  const [isRetrying, setIsRetrying] = useState(false)

  const handleRetry = async () => {
    setIsRetrying(true)
    await new Promise(resolve => setTimeout(resolve, 500))
    window.location.reload()
  }

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <Logo size="lg" className="mx-auto mb-8" />
        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-white">
            Unable to Connect to Server
          </h1>
          <p className="text-gray-400">
            We're having trouble connecting to our servers. This might be due to network issues or server maintenance.
          </p>
        </div>
        <button
          onClick={handleRetry}
          disabled={isRetrying}
          className="w-full max-w-xs mx-auto px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isRetrying ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full mr-2" />
              {/* Retrying... */}
            </div>
          ) : (
            'Try Again'
          )}
        </button>
      </div>
    </div>
  )
}

export default ErrorPage